import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { ChannelRecordingTaskType } from '../types';

import { channelRecordingTasksKeys } from './query-keys';

export type TUploadChannelRecordingTaskFileParams = {
  description: string;
  channel_id: string;
  production_center_id: string;
  segment_duration: number;
  start_time: string;
  end_time: string;
  recording_start_time?: string;
  recording_end_time?: string;
  file: File;
};

export async function uploadChannelRecordingTaskFile(
  params: TUploadChannelRecordingTaskFileParams
): Promise<ChannelRecordingTaskType> {
  const formData = new FormData();

  formData.append('description', params.description);
  formData.append('channel_id', params.channel_id);
  formData.append('production_center_id', params.production_center_id);
  formData.append('segment_duration', String(params.segment_duration));
  formData.append('start_time', params.start_time);
  formData.append('end_time', params.end_time);
  if (params.recording_start_time) {
    formData.append('recording_start_time', params.recording_start_time);
  }
  if (params.recording_end_time) {
    formData.append('recording_end_time', params.recording_end_time);
  }
  formData.append('file', params.file);

  return mediaManagerClient.post(`/api/v1/channel_recording_tasks/files`, formData);
}

type MutationFn = typeof uploadChannelRecordingTaskFile;

type TUseUpdateChannelImagesParams = {
  config?: MutationConfig<MutationFn>;
};

export function useUploadChannelRecordingTaskFile({
  config = {},
}: TUseUpdateChannelImagesParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: uploadChannelRecordingTaskFile,
    onError(error) {
      addErrorNotification(t('No se ha podido crear la grabación'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La grabación se ha creado'));
      queryClient.invalidateQueries({ queryKey: channelRecordingTasksKeys.all });
    },
  });
}
